import {Employee} from '../../interfaces/core/employee';
import {db} from '../db.service';
import {StaticTable} from '../static.table';
import Dexie from 'dexie';
import Promise = Dexie.Promise;

export class EmployeesTable extends StaticTable<Employee> {
  constructor() {
    super(db.employees);
  }

  // @ts-ignore
  public override async getAll(): Promise<Employee[]> {
    return this.table.toCollection().sortBy('fullName');
  }

  public getByServiceFacilityId(serviceFacilityId: number): Promise<Employee[]> {
    return this.table.where('serviceFacilityId').equals(serviceFacilityId).toArray();
  }

}
